import { render, staticRenderFns } from "./WDialogToolbar.vue?vue&type=template&id=58283cec&scoped=true&"
import script from "./WDialogToolbar.vue?vue&type=script&lang=js&"
export * from "./WDialogToolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58283cec",
  null
  
)

export default component.exports